module.exports = __webpack_public_path__ + "static/media/tab.fe0b0270.png";